import { SearchFilter } from '../../models/common/search-filter';
import { OperationError } from '../../models/server-result/operation-error';

export enum UploadDocumentsValidationStatus {
	Valid = 'Valid',
	Invalid = 'Invalid',
}

export class UploadDocumentsSearchCriteria extends SearchFilter {
	fileUploadId: string;
	validationStatusList?: UploadDocumentsValidationStatus[];
	uploadedDocumentType?: string;
	uploadedDocumentNumber?: string;
	uploadedDocumentSupplier?: string;
	uploadedDocumentBuyer?: string;
}

export class UploadDocumentsResult {
	RowNumber: number;
	Type: string;
	Number: string;
	TotalAmount: string;
	Currency: string;
	IssuedDate: string;
	DueDate: string;
	BuyerVat: string;
	BuyerCountryCode: string;
	SupplierVat: string;
	SupplierCountryCode: string;
	BuyerPaymentDate: string;
	ValidationStatus: string;
	ValidationErrors: OperationError[];
	Id: string | null;
	FileUploadId: string | null;
	DocumentNetAmount?: number;
}

export class UploadDocumentsCountCriteria {
	fileUploadId: string;
	validationStatusList?: UploadDocumentsValidationStatus[];
	uploadedDocumentType?: string;
	uploadedDocumentNumber?: string;
	uploadedDocumentSupplier?: string;
	uploadedDocumentBuyer?: string;
}

export class UploadDocumentsValidationCodesResult {
	Type: string;
	Codes: UploadDocumentsValidationStatus[] | null;
}
